import type { presenterShortCollection } from '$lib/api/rpc';
import type { Collection } from '$lib/types/Collections';
import { writable, type Writable } from 'svelte/store';

export const isSideBarOpen = writable(false);

export const selectedCollection: Writable<Collection | presenterShortCollection | undefined> =
	writable(undefined);
export const selectedTag: Writable<undefined | string> = writable(undefined);
